import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { useTableContext } from "../../components/AdministrateTable";
import { History } from "../../tools/sandbox/release/History";
import { useDestroyPermission, useUpdatePermission } from "../../utils";
import { EditSpecialProjectCaseAssignmentModal } from "./EditSpecialProjectCaseAssignmentModal";

export const SpecialProjectCaseAssignmentActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const [canDestroy] = useDestroyPermission("SpecialProjectCaseAssignmentConfig", row.original.id);
  const [canUpdate] = useUpdatePermission("SpecialProjectCaseAssignmentConfig", row.original.id);

  return (
    <>
      {canUpdate && (
        <EditSpecialProjectCaseAssignmentModal
          color="link"
          specialProject={row.original}
          onUpdate={() => {
            refresh();
            setMessage(`Updated Special Project ${row.original.id}.`);
          }}
        />
      )}

      {canDestroy && (
        <AdministrateResourceDeleteButton
          deleteUrl={`/admin/special_project_case_assignment_configs/${row.original.id}`}
          onSuccess={() => {
            refresh();
            setMessage(`Deleted Special Project ${row.original.id}.`);
          }}
          onError={setError}
        />
      )}

      <History entityName="SpecialProjectCaseAssignmentConfig" subjectId={row.original.id} />
    </>
  );
};
